'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _columnConstants = require('./columnConstants');

var _elementRegistry = require('../elements/elementRegistry');

var _elementConstructor = require('../elements/elementConstructor');

var _elementConstructor2 = _interopRequireDefault(_elementConstructor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var objectConstructorFn = function objectConstructorFn(params) {
    var content = params.content;

    return _extends({}, (0, _elementConstructor2.default)(params), {
        elementType: _columnConstants.COLUMN_TYPE,
        content: _extends({
            title: _columnConstants.COLUMN_DEFAULT_TITLE
        }, content)
    });
};

exports.default = function () {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return (0, _elementRegistry.registerElementType)(_extends({
        elementType: _columnConstants.COLUMN_TYPE,
        objectConstructorFn: objectConstructorFn,
        displayName: _columnConstants.COLUMN_DISPLAY_NAME
    }, params));
};


//////////////////
// WEBPACK FOOTER
// ./src/common/columns/index.js
// module id = 2255
// module chunks = 0